module.exports = __webpack_public_path__ + "23ec2a8a29226185087400bfe3165789.svg";